
export default () => ({
  isLoading: false,
  serviceLoaded: false,
  excursions: {
    isLoading: false,
    hasError: false,
    errors: [],
    searchId: null,
    current: {
      price: {
        amount: 0,
        markup: 0,
        currency: 'RUB'
      }
    }
  },
  selected: [],
  form: {
    dateFrom: null,
    dateTo: null,
    type: null,
    goType: null,
    city: {
      slug: null,
      name: null
    }
  },
  details: {
    isLoading: false,
    data: null,
    include: null,
    hasError: false,
    errors: null,
  },
  penalties: {
    isLoading: false,
    hasError: false,
    collection: [],
    errors: []
  },
})